<div class="preview-part">
  <div class="preview-head">
    <h3>{{ 'Preview' | translate }}</h3>

    <div class="preview-head-block">
      <span class="label">{{ 'From' | translate }}:</span>
      <span class="info">{{ preview.from }}</span>
    </div>
    <div class="preview-head-block">
      <span class="label">{{ 'To' | translate }}:</span>
      <span class="info">{{ preview.to }}</span>
    </div>
    <div class="preview-head-block">
      <span class="label">{{ 'Subject' | translate }}:</span>
      <span class="info">{{ preview.subject }}</span>
    </div>
  </div>
  <div class="preview-body">
    <div class="default-text">
      <p>{{ 'Hi' | translate }},</p>
      <p>
        {{ 'This is an automated email to inform you that the following' | translate }}
        {{ triggerType === triggerTypes.MULTI_DROP ? 'Multidrop level' : 'jackpot' | translate }}
        {{ 'has been triggered.' | translate }}
      </p>
      <p>{{ 'To stop receiving these, please contact your Account Manager.' | translate }}</p>
    </div>
    <div class="details-block">
      <div class="details-label top">
        {{ 'Jackpot Details' | translate }}
      </div>
      @if (flags.winTime) {
        <div class="details-group"
        >
          <div class="details-label">
            {{ triggerType === triggerTypes.MULTI_DROP ? 'Date and Time Drop Started' : 'Date and time of win' | translate }}
          </div>
          <div class="details-value">
            {{ preview.winTime | date: "d.M.yy 'at' HH:mm:ss" }}
          </div>
        </div>
      }
      @if (flags.winInPlayer) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Value (Base Currency)' | translate }}
          </div>
          <div class="details-value">
            {{ preview.winInBase }}
          </div>
        </div>
      }
      @if (flags.winInBase) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Value (Player Currency)' | translate }}
          </div>
          <div class="details-value">
            {{ preview.winInPlayer }}
          </div>
        </div>
      }
      @if (flags.progressiveName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Progressive Name' | translate }}
          </div>
          <div class="details-value">
            {{ preview.progressiveName }}
          </div>
        </div>
      }
      @if (flags.jackpotLevelName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Jackpot Level Name' | translate }}
          </div>
          <div class="details-value">
            {{ preview.jackpotLevelName }}
          </div>
        </div>
      }
      @if (flags.licenseeName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Licensee Name' | translate }}
          </div>
          <div class="details-value">
            {{ preview.licenseeName }}
          </div>
        </div>
      }
      @if (flags.operatorName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Operator Name' | translate }}
          </div>
          <div class="details-value">
            {{ preview.operatorName }}
          </div>
        </div>
      }
      @if (flags.gameName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Game' | translate }}
          </div>
          <div class="details-value">
            {{ preview.gameName }}
          </div>
        </div>
      }
      @if (flags.gameName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Skin ID' | translate }}
          </div>
          <div class="details-value">
            {{ preview.skinId }}
          </div>
        </div>
      }
      @if (flags.tierNumber) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Tier No.' | translate }}
          </div>
          <div class="details-value">
            {{ preview.tierNumber }}
          </div>
        </div>
      }
      @if (flags.tierPrizeType) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Prize Type' | translate }}
          </div>
          <div class="details-value">
            {{ preview.tierPrizeType }}
          </div>
        </div>
      }
      @if (flags.tierDisplayName) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Display Name' | translate }}
          </div>
          <div class="details-value">
            {{ preview.tierDisplayName }}
          </div>
        </div>
      }

    </div>

    <div class="details-block">
      @if (flags.playerId) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Player' | translate }}
          </div>
          <div class="details-value">
            {{ preview.playerId }}
          </div>
        </div>
      }
      @if (flags.username) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Username' | translate }}
          </div>
          <div class="details-value">
            {{ preview.username }}
          </div>
        </div>
      }
      @if (flags.playerId) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Player ID' | translate }}
          </div>
          <div class="details-value">
            {{ preview.playerId }}
          </div>
        </div>
      }
      @if (flags.country) {
        <div class="details-group">
          <div class="details-label">
            {{ 'Country' | translate }}
          </div>
          <div class="details-value">
            {{ preview.country }}
          </div>
        </div>
      }
      @if (flags.vipLevel) {
        <div class="details-group">
          <div class="details-label">
            {{ 'VIP Level' | translate }}
          </div>
          <div class="details-value">
            {{ preview.vipLevel }}
          </div>
        </div>
      }
      @if (flags.ip) {
        <div class="details-group">
          <div class="details-label">
            {{ 'IP' | translate }}
          </div>
          <div class="details-value">
            {{ preview.ip }}
          </div>
        </div>
      }
    </div>
  </div>
</div>